import { useQuery } from '@tanstack/react-query';
import {
  getAllUsers,
  getUserById,
  getUserSettings,
  getMyModelsUsage,
  getMyTotalMessages,
  getMyTotalCosts,
  getMyMonthlyCosts,
} from '@/api/userSettings';
import { queryKeys } from '@/lib/queryKeys';

export function useCurrentUserSettingsQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.current(),
    queryFn: getUserSettings,
    enabled,
  });
}

export function useAllUserSettingsQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.list(),
    queryFn: getAllUsers,
    enabled,
  });
}

export function useUserSettingsByIdQuery(userId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.detail(userId ?? ''),
    queryFn: () => getUserById(userId as string),
    enabled: enabled && Boolean(userId),
  });
}

export function useMyModelsUsageQuery(startDate: string, endDate: string, limit: number = 5, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.myModelsUsage(startDate, endDate, limit),
    queryFn: () => getMyModelsUsage(startDate, endDate, limit),
    enabled,
  });
}

export function useMyTotalMessagesQuery(startDate: string, endDate: string, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.myTotalMessages(startDate, endDate),
    queryFn: () => getMyTotalMessages(startDate, endDate),
    enabled,
  });
}

export function useMyTotalCostsQuery(startDate: string, endDate: string, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.myTotalCosts(startDate, endDate),
    queryFn: () => getMyTotalCosts(startDate, endDate),
    enabled,
  });
}

export function useMyMonthlyCostsQuery(numMonths: number = 6, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userSettings.myMonthlyCosts(numMonths),
    queryFn: () => getMyMonthlyCosts(numMonths),
    enabled,
  });
}

